module.exports = __webpack_public_path__ + "img/payment.2298ffbd.webp";